// extracted by mini-css-extract-plugin
export default {"documentList":"DocumentList_documentList__0kJ5W","header":"DocumentList_header__LdDpY","title":"DocumentList_title__W71Pj"};